var _rect, _path, _path2, _path3, _circle, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddToCalendarRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.5,
    width: 19,
    height: 14,
    rx: 0.5,
    fill: "white",
    stroke: "#E81111"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 6H21.5V5H1.5V6Z",
    fill: "#E81111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 -4.37114e-08C5.94772 -6.78526e-08 5.5 0.447715 5.5 1L5.5 2C5.5 2.55228 5.94772 3 6.5 3V3C7.05228 3 7.5 2.55228 7.5 2L7.5 1C7.5 0.447715 7.05228 -1.95703e-08 6.5 -4.37114e-08V-4.37114e-08Z",
    fill: "#E81111"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 -4.37114e-08C15.9477 -6.78526e-08 15.5 0.447715 15.5 1L15.5 2C15.5 2.55228 15.9477 3 16.5 3V3C17.0523 3 17.5 2.55228 17.5 2L17.5 1C17.5 0.447715 17.0523 -1.95703e-08 16.5 -4.37114e-08V-4.37114e-08Z",
    fill: "#E81111"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 15,
    r: 6.5,
    fill: "white",
    stroke: "#E81111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 15C7.5 15.5523 7.94772 16 8.5 16H14.5C15.0523 16 15.5 15.5523 15.5 15C15.5 14.4477 15.0523 14 14.5 14H8.5C7.94772 14 7.5 14.4477 7.5 15Z",
    fill: "#E81111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 19C12.0523 19 12.5 18.5523 12.5 18L12.5 12C12.5 11.4477 12.0523 11 11.5 11C10.9477 11 10.5 11.4477 10.5 12L10.5 18C10.5 18.5523 10.9477 19 11.5 19Z",
    fill: "#E81111"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToCalendarRed);
export default __webpack_public_path__ + "static/media/AddToCalendar-red.07ccfda489b85c1c212fa6a3849a7a6b.svg";
export { ForwardRef as ReactComponent };